import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=6bfe33aa&scoped=true"
import script from "./GroupsTable.ts?vue&type=script&lang=ts&external"
export * from "./GroupsTable.ts?vue&type=script&lang=ts&external"
import style0 from "./GroupsTable.vue?vue&type=style&index=0&id=6bfe33aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe33aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bfe33aa')) {
      api.createRecord('6bfe33aa', component.options)
    } else {
      api.reload('6bfe33aa', component.options)
    }
    module.hot.accept("./GroupsTable.vue?vue&type=template&id=6bfe33aa&scoped=true", function () {
      api.rerender('6bfe33aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/tables/GroupsTable/GroupsTable.vue"
export default component.exports